import React from "react";
import { Route, Switch, Redirect } from 'react-router';

import MessagesPage from "./messages/MessagesPage"
import NoticeboardPage from "./noticeboard/NoticeboardPage";
import TermCalendarPage from "./term_calendar/TermCalendarPage";

import Preloader from "components/teachers/Preloader";
import Guide from "components/teachers/guide/Guide";

import "./TeachersPage.css";

// Root-level /teachers/ component
// Big Switch router for delegating into the individual pages
// Also contains a redirect to default stray navigation into /teachers/messages
export default class TeachersPage extends React.Component {

  render() {
    return(
      <div className="teachers">
        <Preloader>
          <Guide />
          <Switch>
            <Redirect exact from="/teachers/" to="/teachers/messages/" />
            <Route path="/teachers/messages/:schoolID?/" component={MessagesPage} />
            <Route path="/teachers/noticeboard/:schoolID?/" component={NoticeboardPage} />
            <Route path="/teachers/term_calendar/:schoolID?/" component={TermCalendarPage} />
          </Switch>
        </Preloader>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/teachers/TeachersPage.js